import React from "react";
import KaDialog from "../shared/KaDialog";
import Img from "../../assets/unternehmen-online.jpg";
import ImgMobile from "../../assets/unternehmen-online_ausschnitt.jpg";
import { Box, Typography, makeStyles } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import useScreensize from "../../hooks/useScreensize";

const useStyles = makeStyles(theme => ({
  imgBackground: {
    backgroundSize: "cover",
    backgroundPosition: "left center"
  },
  imgTag: {
    width: "100%",
    height: "auto",
    display: "block"
  },
  paragraph: {
    margin: theme.spacing(3, 0)
  },
  link: {
    color: theme.palette.secondary.main,
    textDecoration: "none"
  }
}));

const ServiceDatevUnternehmenOnline = ({ open, close }) => {
  const classes = useStyles();
  const { xs, sm, md, lg, xl } = useScreensize();
  const theme = useTheme();

  const mobile = xs || sm;

  return (
    <>
      <KaDialog title="DATEV Unternehmen online" open={open} close={close}>
        <>
          <Box
            display="flex"
            flexDirection={mobile ? "column" : "row"}
            p={{ xs: 2, sm: 3, md: 3 }}
            height={mobile ? undefined : 600}
          >
            {mobile && (
              <Box mb={3}>
                <img src={ImgMobile} alt="DATEV Unternehmen online" className={classes.imgTag} />
              </Box>
            )}
            <Box
              color="white"
              p={{ xs: 3, sm: 4 }}
              mr={mobile ? 0 : 3}
              bgcolor={theme.palette.primary.main}
              flexShrink={0}
              width={mobile ? "100%" : "65%"}
            >
              <Typography variant="h6" component="h3" gutterBottom>
                <strong>
                  Digitale Zusammenarbeit mit Ihrem Steuerberater – ganz nach
                  Ihrem Bedarf
                </strong>
              </Typography>
              <Typography variant="body1" className={classes.paragraph}>
                Profitieren auch Sie von den Vorteilen der Digitalisierung in
                Ihrem Unternehmen – mit DATEV Unternehmen online.
              </Typography>
              <Typography variant="body1" className={classes.paragraph}>
                Mit dieser DATEV-Lösung arbeiten Sie schnell und sicher mit
                Ihrem Steuerberater zusammen, abgestimmt auf Ihre Anforderungen.
                Das gilt sowohl für die Finanzbuchführung, als auch für die
                Lohnabrechnung.
              </Typography>
              <Typography variant="body1" className={classes.paragraph}>
                So wird vieles einfacher und effizienter.
              </Typography>
              <Typography variant="body1" className={classes.paragraph}>
                Mehr erfahren:
                <br />
                <a
                  className={classes.link}
                  href="https://www.datev.de/web/de/datev-shop/komplettloesungen/datev-unternehmen-online/"
                  target="_blank"
                >
                  www.datev.de/web/de/datev-shop/komplettloesungen/datev-unternehmen-online/
                </a>
              </Typography>
            </Box>
            {!mobile && (
              <Box
                p={3}
                className={classes.imgBackground}
                style={{ backgroundImage: "url(" + Img + ")" }}
                flexGrow={1}
                bgcolor={theme.palette.primary.main}
                flexShrink={1}
                flexBasis="0px"
              ></Box>
            )}
          </Box>
        </>
      </KaDialog>
    </>
  );
};

export default ServiceDatevUnternehmenOnline;
